import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import Header from '../Components/Header';

function ClientDetails() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [userData, setUserData] = useState([]);
  const [accessKey, setAccessKey] = useState([]);
  const [userWallet, setUserWallet] = useState([]);
  const [counts, setCounutts] = useState([]);
  const [networks, setNetwork] = useState([]);
  const [isKeyUpdate, setKeyUpdate] = useState(false);
  const [isWalletUpdate, setWalletUpdatw] = useState(false);
  const user_id = sessionStorage.getItem("clientId");
  const [status, setStatus] = useState("");
  const [fees, setFees] = useState("");
  const [remark, setRemark] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [wallet_id, setWalletID] = useState(null);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabelLoading, setTableLoading] = useState(false); 
  const [selectedAsset, setSelectedAsset] = useState("");
  const [minWithdraw , setMinWithdraw] = useState(0);
  const [maxWithdraw, setMaxWithdraw] = useState(0);

  useEffect(() => {

    const fetchProfileData = async () => {
   //   console.log('Token ', authToken);
      try {
        const client = await fetch(`${baseurl}/client/details?user_id=${user_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (client.status === 429) {
         // console.error("Rate limit exceeded. Please try again later.");
          return; // Stop further processing
        }

        const clientResult = await client.json();
     //   console.log('Static data', clientResult.data);

        if (clientResult.status) {
            setUserData(clientResult.data['user']);
            setAccessKey(clientResult.data['access_key']);
            setUserWallet(clientResult.data['user_wallet']);
            setCounutts(clientResult.data['count']);
            setNetwork(clientResult.data['Network']);
            setTableLoading(true)
        } else {
         // console.error("Error fetching clients:", clientResult.message);
          setTableLoading(true)
        }
      } catch (error) {
       // console.error('Fetch error:', error);
        setTableLoading(true)
      }
    };

    fetchProfileData();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors
  
    if (!status) return setError("Please select a status.");
    if (!remark.trim()) return setError("Remark cannot be empty.");
    if (!password.trim()) return setError("Password is required.");
    if (!userData?.id) return setError("User ID is missing.");
    if (!authToken) return setError("Authentication token is missing.");
  
    const user_id = userData.id;
    const formData = { user_id, remark, status, password };
  
   // console.log("Sending Data:", formData);
  
    try {
      const response = await fetch(`${baseurl}/client/update/access-key`, {
        method: "POST",
        headers: {
           "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json(); // Get raw response
   //   console.log("Raw API Response:", data); // Log response before parsing
  
      if(data.status){
        toast.success(data.message)
        window.location.href = "";
      }
      else
      {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  };
  

  const handleWalletClick = (id) => {
    setWalletUpdatw(prev => !prev);
    setWalletID(id);
};

const updateWalletStatus = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    // **Field validation**
    if (!status) return setError("Please select a status.");
    if (!fees) return setError("Fees cannot be empty.");
    if (!password.trim()) return setError("Password is required.");
    if (!minWithdraw) return setError("Min Withdraw is required.");
    if (!maxWithdraw) return setError("Max Withdraw is required.");
    if (!wallet_id) return setError("Wallet ID is missing.");
    if (!authToken) return setError("Authentication token is missing.");

    const walletIdString = wallet_id ? wallet_id.toString() : ""; // Ensure it's a string safely

    const formData = { 
        wallet_id: walletIdString, 
        status, 
        fees, 
        password,
        min_withdraw: minWithdraw,
        max_withdraw : maxWithdraw 
    }; // Added password safely
   // console.log("Sending Data:", formData);

    try {
        const walletResponse = await fetch(`${baseurl}/client/wallet/asset/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(formData),
        });

        

        const walletData = await walletResponse.json();
       // console.log("Raw API Response:", walletData);

        if (walletData.status) {
            toast.success(walletData.message);
            window.location.href =""
        } else {
            toast.error(walletData.status);
        }
    } catch (error) {
      //  console.error("Fetch error:", error);
        setError("Network error. Please check your connection and try again.");
        toast.error("Network error. Please check your connection and try again.");
    }
};


const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImage(file);
};


const handleSubmitImage = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!image) {
        setError("Please select an image to upload.");
        setLoading(false);
        return;
    }

    if (!wallet_id) {
        setError("Wallet ID is missing.");
        setLoading(false);
        return;
    }

    const formData = new FormData();
    formData.append("wallet_id", wallet_id.toString()); // Ensure wallet_id is a string
    formData.append("asset_image", image); // Append image properly

  //  console.log("Form Data:", formData);

    try {
        const response = await fetch(`${baseurl}/client/wallet/asset/update-logo`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`, // Authentication token
            },
            body: formData, // Send formData
        });

        let result;
        try {
            result = await response.json(); // Parse JSON safely
        } catch (jsonError) {
            throw new Error("Invalid JSON response from server.");
        }

       // console.log("Image Upload Response:", result);

        if (response.ok && result?.status) {
            toast.success("Image uploaded successfully!");
            window.location.href ="";
        } else {
            setError(result?.message || "Failed to upload image.");
        }
    } catch (error) {
     //   console.error("Upload error:", error);
        setError(error.message || "Network error. Please try again.");
    } finally {
        setLoading(false);
    }
};


const handleAddAsset = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!selectedAsset || !password) {
        setError("Please select an asset and enter a password.");
        return;
    }

    setLoading(true);
    setError("");

    try {
        const response = await fetch(`${baseurl}/client/wallet-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`, // Authentication if needed
            },
            body: JSON.stringify({
                user_id: userData.id,
                asset_id: selectedAsset,
                password: password,
            }),
        });

        const data = await response.json();

     //   console.log('Asset Data',data);

        if (response.ok) {
            toast.success("Wallet added successfully!")
            setSelectedAsset("");
            setPassword("");
        } else {
            setError(data.message || "Something went wrong.");
        }
    } catch (error) {
        setError("Server error. Try again.");
    }

    setLoading(false);
};



const handleCopy = () => {
    if (accessKey && accessKey.access_key) {
        navigator.clipboard.writeText(accessKey.access_key)
            .then(() => {
                toast.success("Access key copy successfully !")
            })
            .catch(() => alert("Failed to copy!"));
    }
};


  
  return (
    <>
    <Header>
      <Auth />
      <div className="main-content app-content">
        <div className="container-fluid">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
            <div>
              <h4 className="mb-0">Hi, welcome back!</h4>
            </div>
          </div>
          {/* End Page Header */}

          {/* Table Section */}
          <div className="row row-sm">
            <div className="col-xl-12">
                <div className="card mb-4">
                <div className="card-body">
                    <div className="ps-0">
                    {tabelLoading ? (
                      <div className="main-profile-overview">

                        <div className="row">
                            <div className="col-xl-4 text-center"> 
                                 <span className="avatar avatar-xxl avatar-rounded main-img-user profile-user user-profile ">
                                    <img  src={userData.profile_image} alt="" className="profile-img"/>
                                
                                    </span>
                                    <div className=" mb-4">
                                    <div className="text-center">
                                        <h5 className="main-profile-name">{userData.name || 'N/A'}</h5>
                                        <p className="main-profile-name-text text-muted">{userData.email || 'N/A'}</p>
                                    </div>
                                    </div>
                            </div> 

                            <div className="col-xl-8"> 
                                <label className="main-content-label fs-13 mb-4">Information</label>
                                <div className="main-profile-social-list">
                                <div className="media">
                                    <div className="media-icon bg-primary-transparent text-primary">
                                    <i className="fa fa-mobile" />
                                    </div>
                                    <div className="media-body">
                                    <span>Contact Number</span>{" "}
                                    <a href="javascript:void(0);" className="text-primary">{userData.mobile || 'N/A'}</a>
                                    </div>
                                </div>
                                <div className="media">
                                    <div className="media-icon bg-success-transparent text-success">
                                    <i className="fa fa-envelope" />
                                    </div>
                                    <div className="media-body">
                                    <span>Email</span>{" "}
                                    <a href="javascript:void(0);" className="text-primary">
                                    {userData.email || 'N/A'}
                                    </a>
                                    </div>
                                </div>
                                <div className="media">
                                    <div className="media-icon bg-info-transparent text-info">
                                    <i className="fa fa-key" />
                                    </div>
                                    <div className="media-body">
                                    <span>Access Key</span>
                                    <a href="javascript:void(0);" className="text-primary">
                                    {accessKey && accessKey.access_key ? accessKey.access_key : 'N/A'}
                                    </a>
                                    </div>
                                </div>
                                <div className="media">
                                    <div className="media-icon bg-danger-transparent text-danger">
                                    <i className="icon ion-md-link" />
                                    </div>
                                    <div className="media-body">
                                    <span>Register Date</span>
                                    <span>{userData.created_at ? userData.created_at.slice(0, 16) : 'N/A'}</span>
                                    </div>
                                </div>
                                </div>
                                <hr className="border-0" />
                                        
                            </div>    
                        </div>    
                        
                      
                        
                         
                    </div>
                    ):(
                        <div className="text-center">
                             <div class="d-flex justify-content-center mb-4">
                                  <div class="spinner-border" role="status">
                                      <span class="visually-hidden">Loading...</span>
                                  </div>
                              </div>
                            </div>
                      )}
                    {/* main-profile-overview */}
                    </div>
                </div>
                </div>
            </div>
            <div className="col-xl-12">
                <div className="row row-sm">
                <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                    <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                        <div className="counter-icon bg-primary-transparent">
                            <i className="icon-layers text-primary" />
                        </div>
                        <div className="ms-auto">
                            <h5 className="fs-13">No Of Deposit</h5>
                            <h2 className="mb-0 fs-22 mb-1 mt-1">{counts.no_of_deposit || '0'}</h2>
                            <p className="text-muted mb-0 fs-11">
                            <i className="si si-arrow-up-circle text-success me-1" />
                            increase
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                    <div className="card-body">
                        
                        <div className="counter-status d-flex md-mb-0">
                        <div className="counter-icon bg-danger-transparent">
                            <i className="icon-paypal text-danger" />
                        </div>
                        <div className="ms-auto">
                            <h5 className="fs-13">No Of Tickets</h5>
                            <h2 className="mb-0 fs-22 mb-1 mt-1">{counts.no_of_tickets || '0'}</h2>
                            <p className="text-muted mb-0 fs-11">
                            <i className="si si-arrow-up-circle text-success me-1" />
                            increase
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="col-sm-12 col-lg-4 col-md-12">
                    <div className="card ">
                    <div className="card-body">
                        <div className="counter-status d-flex md-mb-0">
                        <div className="counter-icon bg-success-transparent">
                            <i className="icon-rocket text-success" />
                        </div>
                        <div className="ms-auto">
                            <h5 className="fs-13">Deposit Valume</h5>
                            <h2 className="mb-0 fs-22 mb-1 mt-1">$ {Number(counts.deposit_value || 0).toFixed(2)}</h2>
                            <p className="text-muted mb-0 fs-11">
                            <i className="si si-arrow-up-circle text-success me-1" />
                            increase
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="card">
                {tabelLoading ? (
                <div className="card-body">
                    
                    <div className="tabs-menu ">
                    {/* Tabs */}
                    <ul className="nav nav-tabs profile navtab-custom panel-tabs">
                       <li className="">
                            <a href="#friends01" data-bs-toggle="tab" aria-expanded="false">
                                <span className="visible-xs"><i className="las la-life-ring fs-16 me-1"/></span>
                                <span className="hidden-xs">COMPANY</span>
                            </a>
                        </li>
                        <li className="">
                            <a  href="#home"  data-bs-toggle="tab" className="active"aria-expanded="true">
                                <span className="visible-xs"><i className="las la-key fs-16 me-1" /></span>
                                <span className="hidden-xs">ACCESS KEY</span>
                            </a>
                        </li>
                        <li className="">
                            <a href="#gallery" data-bs-toggle="tab" aria-expanded="false">
                                <span className="visible-xs"><i className="las la-images fs-15 me-1" /> </span>
                                <span className="hidden-xs">WALLETS</span>
                            </a>
                        </li>
                    </ul>
                    </div>
                    <div className="tab-content border border-top-0 p-4 br-dark">
                    <div className="tab-pane border-0 p-0 active" id="home">
                    <div className="card-body p-0">
                    <div className="pt-4 px-4">
                        <div className="main-content-label mb-5"><b className="text-primary">Access Key Details</b></div>
                    </div>
                    
                    <div className="d-flex p-3 border-top">
                        <label className="">
                            <span><i className="fas fa-calendar-check text-danger"></i> </span>
                            <span> <b className="text-primary"> Access key</b></span>
                        </label>
                        <span className="ms-auto">
                        <span>
                           {accessKey && accessKey.access_key ? accessKey.access_key : 'N/A'}
                            </span>
                            &nbsp;&nbsp;
                            <a href="#" onClick={handleCopy}><i className="fa fa-copy text-primary me-2" /></a>
                        </span>
                    </div>
                    <div className="d-flex p-3 border-top">
                        <label className="">
                            <span><i className="fas fa-calendar-check text-danger"></i> </span>
                            <span> <b className="text-primary"> Status</b></span>
                        </label>
                        <span className="ms-auto">
                        <span>
                            {accessKey && accessKey.status
                                ? accessKey.status === 'active' ? (
                                    <span className="badge bg-success">Active</span>
                                ) : (
                                    <span className="badge bg-danger">{accessKey.status} </span>
                                ): 'N/A'}
                            </span>
                            &nbsp;&nbsp;
                            <a href="#" onClick={(e) => { e.preventDefault(); setKeyUpdate(prev => !prev); }}><i className="si si-pencil text-primary me-2" /></a>
                        </span>
                    </div>
                    <div className="d-flex p-3 border-top">
                        <label className="">
                        <span><i className="fa fa-calendar text-danger"></i> </span>
                        <span> <b className="text-primary">Created At</b></span>
                        </label>
                        <span className="ms-auto">
                        <span>{accessKey && accessKey.date_time ? accessKey.date_time : 'N/A'}</span>
                        </span>
                    </div>
                    <div className="d-flex p-3 border-top">
                        <label className="">
                        <span><i className="fa fa-check text-danger"></i> </span>
                        <span> <b className="text-primary">Remark </b></span>
                        </label>
                        <span className="ms-auto">
                        <span>{accessKey && accessKey.remark ? accessKey.remark : 'N/A'}</span>
                        </span>
                    </div>
                    
                    <div className="">
                    
                    {isKeyUpdate && (
                         <form onSubmit={handleSubmit}>
                         <div className="row mt-3 card">
                           <div className="col-12 mt-2">
                             <span>Select Status</span>
                             <select
                               className="form-control"
                               value={status}
                               onChange={(e) => setStatus(e.target.value)}
                             >
                               <option value="">-- Select Status --</option>
                               <option value="active">Active</option>
                               <option value="hold">Hold</option>
                             </select>
                           </div>
                   
                           <div className="col-12 mt-2">
                             <span>Remark</span>
                             <input
                               type="text"
                               className="form-control"
                               placeholder="Enter Remark"
                               value={remark}
                               onChange={(e) => setRemark(e.target.value)}
                             />
                           </div>
                   
                           <div className="col-12 mt-2">
                             <span>Password</span>
                             <input
                               type="password"
                               className="form-control"
                               placeholder="Enter Password"
                               value={password}
                               onChange={(e) => setPassword(e.target.value)}
                             />
                           </div>
                   
                           {error && <p className="text-danger mt-2">{error}</p>}
                   
                           <div className="col-12 mt-2 text-end mb-5">
                             <button type="submit" className="btn btn-sm btn-primary">
                               Update
                             </button>
                           </div>
                         </div>
                       </form>
                       
                        )}

                    </div>
                    </div>

                    </div>
                    <div className="tab-pane border-0 p-0" id="gallery">
                        <div className="row">
                            <div className="mt-3 text-end">
                                <button className="btn btn-success" data-bs-toggle="modal"
                                        data-bs-target="#addAssetModal"><b>+ </b>Add Asset 

                                </button>

                            </div>    
                        <div className="table-responsive country-table">
                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                            <thead>
                                <tr>
                                <th className="wd-lg-25p">Asset</th>
                                <th className="wd-lg-25p">Name</th>
                                <th className="wd-lg-25p">TICKER</th>
                                <th className="wd-lg-25p">NETWORK</th>
                                <th className="wd-lg-25p">Con Address</th>
                                <th className="wd-lg-25p">DEPOSIT</th>
                                <th className="wd-lg-25p">WITHDRAW</th>
                                <th className="wd-lg-25p">REMAIN</th>
                                <th className="wd-lg-25p">SER FEES</th>
                                <th className="wd-lg-25p">Min With</th>
                                <th className="wd-lg-25p">Max With</th>
                                <th className="wd-lg-25p">STATUS</th>
                                <th className="wd-lg-25p">ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userWallet.length > 0 ? (
                                userWallet.map((userWallets, index) => (
                                <tr>
                                      <td> 
                                        <span className="avatar avatar-xm avatar-rounded">
                                          <img className="rouned" src={userWallets.asset_image || 'N/A'}  width={30}/>
                                          <a  onClick={() => setWalletID(userWallets.id)} href="javascript:void(0);"  className="badge rounded-pill bg-primary avatar-badge profile-edit" data-bs-toggle="modal"
                                        data-bs-target="#exampleModal">
												<i className="fe fe-camera"></i>
											</a>
                                        </span>
                                     </td>
                                     <td><span>{userWallets.asset_name || 'N/A'} </span></td>
                                     <td><span>{userWallets.asset_ticker || 'N/A'} </span></td>
                                     <td><span>{userWallets.blockchain_network || 'N/A'} </span></td>
                                     <td><span>{userWallets.contract_address || 'N/A'} </span></td>
                                     <td><span>{userWallets.deposit || '0'} </span></td>
                                     <td><span>{userWallets.withdraw || '0'} </span></td>
                                     <td><span>{userWallets.remain || '0'} </span></td>
                                     <td><span>{userWallets.fees || '0'} % </span></td>
                                     <td><span>{userWallets.min_withdraw || '0'}  </span></td>
                                     <td><span>{userWallets.max_withdraw || '0'} </span></td>
                                     <td>
                                        {userWallets && userWallets.status
                                        ? userWallets.status === 'enable' ? (
                                            <span className="badge bg-success">enable</span>
                                        ) : (
                                            <span className="badge bg-danger">{userWallets.status} </span>
                                        ): 'N/A'}
                                    </td>
                                    <td><a onClick={() => handleWalletClick(userWallets.id)} className="btn btn-primary btn-sm"><i className="fa fa-edit"> </i> EDIT </a></td>
                                </tr>
                                ))
                                ) : (
                                <tr>
                                <td>No Data Found</td>
                                </tr>
                                )}
                            </tbody>
                            </table>

                           

                        </div>
                        {isWalletUpdate && (
                                <form onSubmit={updateWalletStatus}>
                                <div className="row mt-3 card">
                                <div className="col-12 mt-2">
                                    <span>Select Status</span>
                                    <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value="">-- Select Status --</option>
                                    <option value="enable">Enable</option>
                                    <option value="disable">Disable</option>
                                    </select>
                                </div>
                        
                                <div className="col-12 mt-2">
                                    <span>Service Fees</span>
                                    <input  type="text"  className="form-control" placeholder="Enter Fees" value={fees} onChange={(e) => setFees(e.target.value)}/>
                                </div>
                                

                                <div className="col-12 mt-2">
                                    <span>Min Withdraw</span>
                                    <input type="text" className="form-control" placeholder="Enter Password" value={minWithdraw} onChange={(e) => setMinWithdraw(e.target.value)}/>
                                </div>

                                <div className="col-12 mt-2">
                                    <span>Max Withdraw</span>
                                    <input type="text" className="form-control" placeholder="Enter Password" value={maxWithdraw} onChange={(e) => setMaxWithdraw(e.target.value)}/>
                                </div>

                                <div className="col-12 mt-2">
                                    <span>Password</span>
                                    <input type="password" className="form-control" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                                </div>
                                {error && <p className="text-danger mt-2">{error}</p>}
                        
                                <div className="col-12 mt-2 text-end mb-5">
                                    <button type="submit" className="btn btn-sm btn-primary">Update</button>
                                </div>
                                </div>
                               </form>
                            )}
                        </div>
                    </div>

                    <div className="tab-pane border-0 p-0" id="friends01" role="tabpanel">
                        <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                            <div className="card custom-card border shadow-none">
                            <div className="card-body  user-lock text-center">
                                
                               
                                <img
                                    alt="avatar"
                                    className="rounded-circle"
                                    src={userData.compnay_logo || ''}
                                />
                                <h5 className="fs-16 mb-0 mt-3 text-dark fw-semibold">
                                   {userData.company_name || 'N/A'}
                                </h5>
                                <span className="text-muted">{userData.company_name}</span>
                                <div className="mt-3 d-flex mx-auto text-center justify-content-center">
                                    <span className="btn btn-icon btn-outline-primary rounded-circle border me-3">
                                    <i className="bx bxl-facebook fs-16 align-middle" />
                                    </span>
                                    <span className="btn btn-icon btn-outline-primary rounded-circle border me-3">
                                    <i className="ri-twitter-x-fill fs-16 align-middle" />
                                    </span>
                                    <span className="btn btn-icon btn-outline-primary rounded-circle border">
                                    <i className="bx bxl-linkedin fs-16 align-middle" />
                                    </span>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
               
                </div>
                 ):(
                    <div className="cord-body">
                        <div className="text-center">
                         <div class="d-flex justify-content-center mb-4">
                              <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                              </div>
                          </div>
                        </div>
                    </div>    

                  )}
                </div>
            </div>
          </div>

          {/* /Table Section */}
        </div>
      </div>

      <div className="modal fade" id="exampleModal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id="exampleModalLabel1">Update Logo</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <form onSubmit={handleSubmitImage}>
                        <div className="mt-3">
                            <label>Choose Image</label>
                            <input 
                                type="file" 
                                className="form-control mt-3"  
                                name="assetImage" 
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </div>
                        {error && <p className="text-danger">{error}</p>}
                        <div className="mt-3 text-end">
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Uploading..." : "Confirm"}
                            </button>
                        </div>
                    </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger"
                            data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


        <div className="modal fade" id="addAssetModal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id="exampleModalLabel1">Add Asset</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <form onSubmit={handleAddAsset}>
                        <div className="mt-3">
                            <label>Select Asset</label>
                            <select className="form-control" value={selectedAsset} onChange={(e) => setSelectedAsset(e.target.value)}>
                        <option value="">Select Asset</option>
                                {Array.isArray(networks) && networks.length > 0 ? (
                                    networks.map((networkAsset, index) => (
                                        <option key={index} value={networkAsset.id}>
                                            {networkAsset.asset_name || "Unnamed Asset"} <b className="text-danger">{networkAsset.network || "Unnamed Asset"}</b>
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No assets available</option>
                                )}
                            </select>
                            <br></br>
                            <lavel className="mt-5">Enter Password</lavel>
                            <input type="text" className="form-control" value={password}  onChange={(e)=>setPassword(e.target.value)}/>


                        </div>
                        {error && <p className="text-danger">{error}</p>}
                        <div className="mt-3 text-end">
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Uploading..." : "Confirm"}
                            </button>
                        </div>
                    </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger"
                            data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
      <ToastContainer/>
      </Header>
      <Footer />
    </>
  );
}

export default ClientDetails;
